/* 
Author:Lamiaa Moustafa
Desc: Reusable Logo component
*/

import React from 'react'
import styled from "styled-components";
import CaLogo from "../assets/svgs/1st2911_logo.svg"

 export const Logo = () => {

  return (
    <Img className="CaLogo" src={CaLogo} alt=" Covert Alert Logo" />
  )
}
;

const Img = styled.img`
display:block;
width:180px;
  @media screen and (max-width: 570px) {
    width:100px;
  }
`